import { configureStore } from "@reduxjs/toolkit";
import khachHangReducer from "./slices/khachHangSlice";
import dichVuReducer from "./slices/dichVuSlice";
import nhomDichVuReducer from "./slices/nhomDichVuSlice";
import hangHoaReducer from "./slices/hangHoaSlice";
import nhanVienReducer from "./slices/nhanVienSlice";
import phongBanReducer from "./slices/phongBanSlice";
import vaiTroReducer from "./slices/vaiTroSlice";
import nhomHangHoaReducer from "./slices/nhomHangHoaSlice";
import thanhToanReducer from "./slices/thanhToanSlice";
import clsReducer from "./slices/clsSlice";
import caidatReducer from "./slices/caidatSlice";
import reportReducer from "./slices/reportSlice";

const store = configureStore({
  reducer: {
    khachHang: khachHangReducer,
    dichVu: dichVuReducer,
    hangHoa: hangHoaReducer,
    nhanVien: nhanVienReducer,
    phongBan: phongBanReducer,
    vaiTro: vaiTroReducer,
    nhomDichVu: nhomDichVuReducer,
    nhomHangHoa: nhomHangHoaReducer,
    thanhToan: thanhToanReducer,
    cls: clsReducer,
    caidat: caidatReducer,
    report: reportReducer,
  },
});

export default store;
